import { createStyles } from "@material-ui/core";
import theme from "../../theme";

export default createStyles({

  root: { },

  appBar: {
    backgroundColor: theme.palette.common.white
  },

  toolBar: { },

  logo: { },

  selectRoot: { },

  menuItem: { },

  button: { },

});